import { AdjustmentNoteCategoryEnum, AdjustmentNoteStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PurchasesEntity } from "./purchases.entity";

@Entity("purchase_products")
export class PurchaseProductsEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"purchase_product_id"
    }) 
    purchaseProductId: number;

    @Column('decimal',{
        name:'unit_price',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    unitPrice:number

    @Column('decimal',{
        name:'cases',
        nullable:false,
        precision:10,scale:3,
        unsigned:true,
    })
    cases:number
    @Column('decimal',{
        name:'total_amount',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    totalAmount:number
    
    @Column('decimal',{
        name:'case_weight',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    caseWeight:number

    @Column('decimal',{
        name:'net_weight',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    netWeight:number

    @Column('int',{
        name:'tax_id',
        nullable:false,
    })
    taxId:number

    @Column('int',{
        name:'product_id',
        nullable:false,
    })
    productId:number
    
    @Column('int',{
        name:'pack_style_id',
        nullable:false,
    })
    packStyleId:number

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @ManyToOne(type => PurchasesEntity, val => val.purchaseProductsInfo, { nullable: false, })
    @JoinColumn({ name: "purchase_id" })
    purchasesInfo: PurchasesEntity[];
    
}